import React from 'react'
import './Footer.css'

export default class Footer extends React.Component {
  render() {
    return (
      <div>
        <footer id="footer">
          <ul>
            <li><a href="mailto:jonathan.moore6247@gmail.com">Email me at: jonathan.moore6247@gmail.com</a></li>
          </ul>
        </footer>
      </div>
    )
  }
}